import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthContext';
import { Alert, Loading } from './ui';

/** Any signed-in user. Sends anonymous visitors to /login, remembering where they were. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <>{children}</>;
}

/**
 * Admin-only. Renders a plain refusal rather than redirecting so a signed-in
 * non-admin who lands here understands why, instead of bouncing to a login
 * screen they are already past.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (!isAdmin) return <Alert tone="error">Forbidden — this page requires an admin account.</Alert>;
  return <>{children}</>;
}
